import { useState } from "react";
import { Hero } from "../components/Hero";
import { Marquee } from "../components/Marquee";
import { Welcome } from "../components/Welcome";
import { Shop } from "../components/Shop";
import { ProductModal } from "../components/ProductModal";
import { CustomOrder } from "../components/CustomOrder";
import { HowItWorks } from "../components/HowItWorks";
import { scrollToId } from "../lib/smooth";

export default function Home() {
  const [category, setCategory] = useState("All");
  const [product, setProduct] = useState(null);
  const pick = (c) => {
    setCategory(c);
    scrollToId("shop");
  };
  return (
    <main>
      <Hero />
      <Marquee />
      <Welcome onCategory={pick} />
      <Shop category={category} setCategory={setCategory} onOpen={setProduct} />
      <HowItWorks />
      <CustomOrder />
      <ProductModal product={product} onClose={() => setProduct(null)} />
    </main>
  );
}
